'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BritannicaApi = function (_BaseApi) {
  (0, _inherits3.default)(BritannicaApi, _BaseApi);
  function BritannicaApi() {
    (0, _classCallCheck3.default)(this, BritannicaApi);
    return (0, _possibleConstructorReturn3.default)(this, (BritannicaApi.__proto__ || Object.getPrototypeOf(BritannicaApi)).call(this, _frontendUtils.endpoints.britannicaBaseUrl));
  }
  (0, _createClass3.default)(BritannicaApi, [{
    key: 'getAllLists',
    value: function getAllLists() {
      return this.makeRequest({
        method: 'GET',
        url: 'list/all'
      });
    }
  }, {
    key: 'addToList',
    value: function addToList(name, option) {
      return this.makeRequest({
        method: 'POST',
        url: 'list/' + name,
        body: option
      });
    }
  }, {
    key: 'createList',
    value: function createList(list) {
      return this.makeRequest({
        method: 'POST',
        url: 'list',
        body: list
      });
    }
  }, {
    key: 'getDomainCount',
    value: function getDomainCount() {
      return this.makeRequest({
        method: 'GET',
        url: 'domain/_count'
      });
    }
  }, {
    key: 'getSourceCount',
    value: function getSourceCount() {
      return this.makeRequest({
        method: 'GET',
        url: 'source/_count'
      });
    }
  }, {
    key: 'getDomainByHostName',
    value: function getDomainByHostName(hostName) {
      if (!ValidationUtils.isNonEmptyOrBlankString(hostName)) {
        return Promise.reject(new _ParameterError2.default('hostName', hostName, 'string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'domain/_hostName/' + hostName
      });
    }
  }, {
    key: 'searchDomains',
    value: function searchDomains(params) {
      return this.makeRequest({
        method: 'POST',
        url: 'domain/search',
        body: params
      });
    }
  }, {
    key: 'searchSources',
    value: function searchSources(params) {
      return this.makeRequest({
        method: 'POST',
        url: 'source/search',
        body: params
      });
    }

    /**
     * Creates a new domain
     * @return {Promise} Promise resolves with domain object, if finished successfully. Otherwise promise rejects with ResponseError object.
     */
  }, {
    key: 'createDomain',
    value: function createDomain(value) {
      if (!ValidationUtils.isObject(value)) {
        return Promise.reject(new _ParameterError2.default('value', value, 'JS object.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(value.hostName)) {
        return Promise.reject(new _ParameterError2.default('value.hostName', value.hostName, 'string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'domain',
        body: value
      });
    }

    /**
     * Obtains a single instance of a domain.
     * @param  {String} domainId    ID of the domain to be obtained.
     * @return {Promise}            Promise resolves with domain data, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'getDomain',
    value: function getDomain(domainId) {
      if (!ValidationUtils.isNonEmptyOrBlankString(domainId)) {
        return Promise.reject(new _ParameterError2.default('domainId', domainId, 'string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'domain/' + domainId
      });
    }

    /**
     * Creates a new source
     * @return {Promise} Promise resolves with source object, if finished successfully. Otherwise promise rejects with ResponseError object.
     */
  }, {
    key: 'createSource',
    value: function createSource(value) {
      if (!ValidationUtils.isObject(value)) {
        return Promise.reject(new _ParameterError2.default('value', value, 'JS object.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(value.serviceGuid)) {
        return Promise.reject(new _ParameterError2.default('value.serviceGuid', value.serviceGuid, 'string.'));
      }
      if (!ValidationUtils.isNonEmptyOrBlankString(value.serviceType)) {
        return Promise.reject(new _ParameterError2.default('value.serviceType', value.serviceType, 'string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'source',
        body: value
      });
    }

    /**
     * Obtains a single instance of a source.
     * @param  {String} sourceId    ID of the source to be obtained.
     * @return {Promise}            Promise resolves with domain data, if request was successful. Otherwise promise rejects with ParameterError or ResponseError object.
     */
  }, {
    key: 'getSource',
    value: function getSource(sourceId) {
      if (!ValidationUtils.isNonEmptyOrBlankString(sourceId)) {
        return Promise.reject(new _ParameterError2.default('sourceId', sourceId, 'string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'source/' + sourceId
      });
    }
  }, {
    key: 'getSourcesForDomain',
    value: function getSourcesForDomain(domainUrl) {
      if (!ValidationUtils.isNonEmptyOrBlankString(domainUrl)) {
        return Promise.reject(new _ParameterError2.default('domainUrl', domainUrl, 'string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'public/domain/sources',
        queryParameters: {
          url: domainUrl
        },
        retryMax: 1
      });
    }
  }, {
    key: 'updateSource',
    value: function updateSource(sourceId) {
      var patch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!ValidationUtils.isNonEmptyOrBlankString(sourceId)) {
        return Promise.reject(new _ParameterError2.default('sourceId', sourceId, 'string.'));
      }
      if (!ValidationUtils.isObject(patch)) {
        return Promise.reject(new _ParameterError2.default('value', patch, 'JS object.'));
      }
      return this.makeRequest({
        method: 'PATCH',
        url: 'source/' + sourceId,
        body: patch
      });
    }
  }, {
    key: 'updateDomain',
    value: function updateDomain(domainId) {
      var patch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!ValidationUtils.isNonEmptyOrBlankString(domainId)) {
        return Promise.reject(new _ParameterError2.default('domainId', domainId, 'string.'));
      }
      if (!ValidationUtils.isObject(patch)) {
        return Promise.reject(new _ParameterError2.default('value', patch, 'JS object.'));
      }
      return this.makeRequest({
        method: 'PATCH',
        url: 'domain/' + domainId,
        body: patch
      });
    }
  }]);
  return BritannicaApi;
}(_BaseApi3.default);
exports.default = BritannicaApi;